var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFaq = function SvgFaq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.946 5c-3.86-3.86-10.141-3.86-14 0-3.86 3.859-3.86 10.14 0 14 3.859 3.86 10.14 3.86 14 0 3.86-3.86 3.86-10.141 0-14ZM17.94 17.994c-3.306 3.307-8.686 3.307-11.991 0-3.307-3.305-3.307-8.684 0-11.99 3.305-3.305 8.685-3.307 11.991 0 3.305 3.305 3.305 8.685 0 11.99Z",
    fill: "#5C7AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.735 16.08a.87.87 0 1 0 .87.868.87.87 0 0 0-.87-.869ZM11.855 6.214c-1.696 0-3.194.976-3.724 2.43-.124.34-.23.906-.124 1.377a.626.626 0 0 0 .734.466.615.615 0 0 0 .465-.733c-.036-.17-.001-.472.079-.69.293-.805 1.201-1.618 2.569-1.618 1.61 0 2.733.822 2.733 2 0 .881-.546 1.2-1.512 1.689-.874.442-1.963.99-1.963 2.374v1.256c0 .34.276.616.614.616a.616.616 0 0 0 .615-.616V13.51c.001-.6.444-.851 1.29-1.278.975-.491 2.19-1.102 2.19-2.784 0-1.903-1.631-3.233-3.966-3.233Z",
    fill: "#5C7AFF"
  })));
};

export default SvgFaq;